import React from "react";
import styled from "styled-components";

const SectionTitleStyle = styled.div`
  text-align: center;
  p {
    font-family: "RobotoMono Regular";
    font-size: 2rem;
    color: white;
  }
  h2 {
    font-family: "Montserrat Bold";
    color: white;
    font-size: 4.2rem;
    margin-top: 0.5rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    text-align: center;
    p {
      font-size: 1.3rem;
    }
    h2 {
      font-size: 3.1rem;
    }
  }
`;

export default function SectionTitle({
  subheading = "Need Subheading",
  heading = "need heading",
}) {
  return (
    <SectionTitleStyle className="section-title">
      <p>{subheading}</p>
      <h2>{heading}</h2>
    </SectionTitleStyle>
  );
}
